import { useEffect } from 'react';
import { useObserver } from 'mobx-react-lite';
import { useDutchiePay } from 'components/dutchie-pay';
import useCart from 'shared/hooks/use-cart';
import useUser from 'shared/hooks/use-user';
import { tracker } from '..';

export const useViewedCheckoutMonitor = (): void => {
  const { isEnrolledDutchiePay, isDutchiePayEnabledForDispo } = useDutchiePay();
  const Cart = useCart();
  const user = useUser();
  const userId = useObserver(() => user.id);

  const { checkoutToken, dispensary } = Cart.order ?? {};
  const { id: dispensaryId, name: dispensaryName } = dispensary ?? {};

  useEffect(() => {
    if (userId === undefined || dispensary === undefined || Cart.order === undefined) {
      return;
    }

    tracker.setContext({
      activeUser: {
        id: userId,
      },
      activeDispensary: dispensary,
      activeCart: { subtotal: Cart.costBreakdown.subtotal, ...Cart.order.cart },
      activeOrder: Cart.order,
      checkoutToken: Cart.checkoutToken,
    });
  }, [userId, dispensary, Cart.checkoutToken, Cart.order, Cart.costBreakdown.subtotal]);

  useEffect(() => {
    const payloadProps = [
      checkoutToken,
      dispensaryId,
      dispensaryName,
      isDutchiePayEnabledForDispo,
      isEnrolledDutchiePay,
    ];

    if (payloadProps.some((value) => value === undefined)) {
      return;
    }

    tracker.viewedCheckout({
      checkoutToken,
      dispensaryId,
      dispensaryName,
      isDutchiePayEnabledForDispo,
      isEnrolledDutchiePay,
    });
  }, [checkoutToken, dispensaryId, dispensaryName, isDutchiePayEnabledForDispo, isEnrolledDutchiePay]);
};
